import Controller from "./editableFormControls.controller";
import template from "./editableFormControls.html";

const editableFormControls = {
  template,
  controller: Controller,
  bindings: {
    fieldTitle: "@",
    isDisabled: "=?",
    submitCallback: "<",
    submitDisabled: "<",
    editDisabled: "<",
  },
};

export default editableFormControls;



// WEBPACK FOOTER //
// ./src/components/editableFormControls/editableFormControls.component.js